module.exports = __webpack_public_path__ + "458392b5c86e98d3f4a4d5886677e637-computer_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/resources/assets/computer_2x.png
// module id = 703
// module chunks = 0